import { render, staticRenderFns } from "./organization-signup.vue?vue&type=template&id=6b6d1af7&"
import script from "./organization-signup.vue?vue&type=script&lang=js&"
export * from "./organization-signup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports